import { useContext, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { FaTimes} from "react-icons/fa";
import { AppContext } from "../../context/AppContext";
import { taskListActions } from "../../context/reducer";

const Popup = (props) => {
    const {
        setToastOpen,
        toastProps,
        setToastProps,
        setOpen
    } = props;
    const {
        state: {taskList},
        dispatch
    } = useContext(AppContext);

    const [formData, setFormData] = useState(null);

    const onFormSubmit = () => {
        dispatch({type: taskListActions.UPDATE_TASKLIST, payload: [...taskList, {...formData, isActive: true, isCompleted: false, isArchived: false, show: true}]})
        setToastProps({...toastProps, message: 'Task Added Successfully', variant: 'success'})
        setToastOpen(true);
        setOpen(false);
    } 

    return (
    <div className='popup-container'>
        <span className='popup-overlay'></span>
        <div className='popup-content'>
            <div className="popup-content-header">
                <h4 className="text-dark-600 font-[500] text-[18px]">Add new task</h4>
                <span className='close-btn' onClick={() => setOpen(false)}><FaTimes /></span>
            </div>
            <div className="popup-content-body">
                <div className="input-wrapper">
                    <label>Title</label>
                    <input onInput={e => setFormData({...formData, title: e.target.value})} type="text" className="border-1 border-gray-300 focus:border-blue-300" />
                </div>
                <div className="input-wrapper">
                    <label>Description</label>
                    <textarea onInput={e => setFormData({...formData, description: e.target.value})} className=" border-1 border-gray-300 focus:border-blue-300" />
                </div>
                <div className="input-wrapper">
                    <label>Start Time</label>
                    <input type="time" onBlur={e => setFormData({...formData, startTime: e.target.value})} className="border-1 border-gray-300 focus:border-blue-300" />
                </div>
                <div className="input-wrapper">
                    <label>End Time</label>
                    <input type="time" onBlur={e => setFormData({...formData, endTime: e.target.value})} placeholder='when to end' className="border-1 border-gray-300 focus:border-blue-300" />
                </div>
            </div>
            <div className="popup-content-footer">
                <button onClick={onFormSubmit} className="flex items-center block bg-blue-600 text-white w-[100%] justify-center p-2 rounded-[10px]"><BiPlus /> Add task</button>
            </div>
        </div>
    </div>
    )
}
export default Popup;